"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "behavior", {
    enumerable: !0,
    get: function() {
        return n;
    }
}), require("miniprogram-api-typings");
var i = require("./core"), n = Behavior({
    definitionFilter: function(n) {
        n.methods = n.methods || {};
        var r = n.storeBindings;
        n.storeBindings = void 0, r && (n.methods._mobxMiniprogramBindings = function() {
            return r;
        }, Array.isArray(r) ? r.forEach(function(r) {
            (0, i.createActions)(n.methods, r);
        }) : (0, i.createActions)(n.methods, r));
    },
    lifetimes: {
        attached: function() {
            var n = this;
            if ('function' == typeof n._mobxMiniprogramBindings) {
                var r = n._mobxMiniprogramBindings();
                if (!r) {
                    n._mobxMiniprogramBindings = null;
                    return;
                }
                Array.isArray(r) ? n._mobxMiniprogramBindings = r.map(function(r) {
                    var o = (0, i.createDataFieldsReactions)(n, r);
                    return o.updateStoreBindings(), o;
                }) : (n._mobxMiniprogramBindings = (0, i.createDataFieldsReactions)(this, r), n._mobxMiniprogramBindings.updateStoreBindings());
            }
        },
        detached: function() {
            this._mobxMiniprogramBindings && (Array.isArray(this._mobxMiniprogramBindings) ? this._mobxMiniprogramBindings.forEach(function(i) {
                i.destroyStoreBindings();
            }) : this._mobxMiniprogramBindings.destroyStoreBindings());
        }
    },
    methods: {
        updateStoreBindings: function() {
            this._mobxMiniprogramBindings && 'function' != typeof this._mobxMiniprogramBindings && (Array.isArray(this._mobxMiniprogramBindings) ? this._mobxMiniprogramBindings.forEach(function(i) {
                i.updateStoreBindings();
            }) : this._mobxMiniprogramBindings.updateStoreBindings());
        }
    }
});
